<template>
  <div v-if="items.length > 0 " class="mt-4 card mb-6">
    <div class="card-header">
      <h3 class="card-title">Frequently Bought Together</h3>
    </div>
    <div class="card-body row">
      <div v-for="item in items" v-bind:key="item.groupId" class="col-lg-3 col-md-4 col-sm-6">
        <div class="card mb-4 position-relative card-link shadow-sm border-0 rounded-3">
          <div class="fbt-photo">
            <img :src="generateImage(item)" class="card-img-top" :alt="'Product Image of '+item.name" loading="lazy" decoding="async"
                 :class="{ 'image-loaded': loaded[item.sku] }" @load="loaded[item.sku] = true" @error="onImageError">
          </div>
          <div class="card-footer">
            <a class="stretched-link text-reset" :href="`/products/${item.group}/${item.sku}`" :aria-label="`View ${item.name}`">{{ item.name }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import api from "@/services/api";

export default {
  name: "FBT",
  data() {
    return {
      items: [],
      // Which photos (by sku) have arrived; until then the box shows its neutral background.
      loaded: {}
    }
  },
  async mounted() {
    try {
      const itemsResp = await api.get('/api/fbt/sku/' + this.$route.params.productId)
      this.items = itemsResp.data;
      console.log("Items", this.items)
    } catch (error) {
      console.log(error)
    }
  },
  methods: {
    generateImage(item) {
      return `https://larkhallbutchers.co.uk/cdn-cgi/image/width=640/${item.productImage}`
    },
    // As on the product tiles: a photo that cannot be fetched becomes the shop's logotype.
    onImageError(event) {
      if (!event.target.src.endsWith('/LHB-LogoType.svg')) event.target.src = '/LHB-LogoType.svg'
    },
  }
}
</script>

<style scoped>
/* Same reserved 4:3 box, neutral background and fade as the product tiles. */
.fbt-photo {
  position: relative;
  aspect-ratio: 4 / 3;
  overflow: hidden;
  background-color: #f8f9fa;
  border-radius: 0.75rem 0.75rem 0 0;
}
.fbt-photo img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0;
  transition: opacity 0.3s ease;
}
.fbt-photo img.image-loaded {
  opacity: 1;
}
/* Ensure product titles clamp to two lines and vertically center within reserved space */
.card-footer {
  display: flex;
  align-items: center;
  min-height: calc(1.25em * 2 + 1rem);
}
.card-footer .stretched-link {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.25;
  word-break: break-word;
}
</style>
